import React, { useEffect } from "react";
import moment from "moment";
import { Button, Checkbox } from "@mui/material";
import { CommonConfirmationDialog } from "../../components/DialogComponent/SupplyDataDialog";

export default function AppointmentSelection({
  appointments,
  selectedIds,
  setSelectedIds,
  selectionLocked,
  setSelectionLocked,
  navigate,
  setNumberOfTime,
  setRecurringDates,
  mode,
  editAppointmentData
}) 
{
  const [open, setOpen] = React.useState(false);

    useEffect(() => {
        if (mode === "all" && appointments?.length > 0) {
            setSelectedIds(appointments?.map(a => a?.id));
            setSelectionLocked(true);
            setNumberOfTime(appointments.length);
        }
    }, [mode, appointments]);

  return (
    <>
      {mode === "this" ? (
        <div
          className="bg-[#fff] dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0"
          style={{
            width: "50%",
            display: "flex",
            flexDirection: "column",
            marginTop: "15px",
            borderRadius: 12,
            padding: 14,
            border: "1px solid #ddd",
          }}
        >
          <h2 style={{ fontSize: "16px", fontWeight: "600", marginBottom: 8 }}>
            Selected Appointments
          </h2>

          <div
            style={{
              maxHeight: "260px",
              overflowY: "auto",
              paddingRight: "6px",
              marginBottom: "16px",
            }}
          >
            {editAppointmentData?.map((appt) => {
              const apptTime = new Date(appt.apoointmentDetails.appointmentDateTime);

              return (
                <div
                  key={appt?.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    borderRadius: 8,
                    background: "transparent",
                    opacity: 0.7,
                  }}
                >
                  <Checkbox
                    disabled={true}
                    checked={true}
                    style={{ padding: "6px" }}
                    color="success"
                  />

                  <div style={{ marginLeft: 12 }}>
                    <div style={{ fontWeight: 600 }}>
                      {moment(apptTime).format("hh:mm a on MMMM DD, YYYY")}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <>
          <div
            className="bg-[#fff] dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0"
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
              marginTop: "15px",
              borderRadius: 12,
              padding: 14,
              border: "1px solid #ddd",
            }}
          >
            <h2 style={{ fontSize: "16px", fontWeight: "600", marginBottom: 8 }}>
              Select Appointments to Modify
            </h2>

            <div
              style={{
                maxHeight: "260px",
                overflowY: "auto",
                paddingRight: "6px",
                marginBottom: "16px",
              }}
            >
              {appointments?.map((appt) => {
                const apptTime = new Date(appt.apoointmentDetails.appointmentDateTime);
                const checked = selectedIds.includes(appt.id);

                return (
                  <div
                    key={appt?.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      borderRadius: 8,
                      background: "transparent",
                      opacity: selectionLocked && !checked ? 0.5 : 1,
                    }}
                  >
                    <Checkbox
                      disabled={selectionLocked}
                      checked={checked}
                      style={{ padding: "6px" }}
                      color="success"
                      onChange={(e) => {
                        if (e.target.checked)
                          setSelectedIds((s) => [...s, appt.id]);
                        else
                          setSelectedIds((s) =>
                            s.filter((id) => id !== appt.id)
                          );
                      }}
                    />

                    <div style={{ marginLeft: 12 }}>
                      <div style={{ fontWeight: 600 }}>
                        {moment(apptTime).format("hh:mm a on MMMM DD, YYYY")}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {selectedIds?.length === 0 && (
              <div className="text-orange-500 text-md mt-8">
                Please select at least one appointment date to continue with rescheduling.
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: selectionLocked ? "flex-end" : "space-between",
                marginTop: 30,
              }}
            >
              {!selectionLocked ? (
                <>
                  <Button variant="outlined" className="dark:text-white" onClick={() => setOpen(true)}>
                    Cancel
                  </Button>

                  <Button
                    variant="contained"
                    className="dark:text-white"
                    style={{
                      backgroundColor:
                        selectedIds?.length === 0 ? "#7f7f7f" : "#10bf63",
                      color: "white",
                    }}
                    disabled={selectedIds?.length === 0}
                    onClick={() => {
                      setSelectionLocked(true);
                      setNumberOfTime(selectedIds?.length);
                      setRecurringDates([]);
                    }}
                  >
                    Proceed
                  </Button>
                </>
              ) : (
                <div style={{ width: "100%" }}>
                  <Button
                    fullWidth
                    variant="outlined"
                    className="dark:text-white"
                    style={{ marginBottom: 12 }}
                    onClick={() => setSelectionLocked(false)}
                  >
                    Edit Selection
                  </Button>
                </div>
              )}
            </div>
          </div>

          <CommonConfirmationDialog
            open={open}
            onConfirm={() => navigate("/operations/manageAppointments")}
            onClose={() => setOpen(false)}
            title="Cancel Rescheduling"
            message="Are you sure you want to cancel rescheduling your appointment(s)?"
          />
        </>
      )}
    </>
  );
}
